import React from 'react';

export default function FwPromotionIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-tags' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}